// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import AccountSettingNavigation from 'presentations/views/components/organisms/AccountSettingNavigation';
import FormContentHeader from 'presentations/views/components/molecules/FormContentHeader';

interface Props {
  currentUrl: string;
  icon: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <>
      <FormContentHeader
        icon={props.icon}
        title={t('title')}
        description={t('description')}
      />
      <AccountSettingNavigation currentUrl={props.currentUrl} />
    </>
  );
}
